import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Variant = 'default' | 'magenta' | 'gold' | 'navy' | 'success' | 'warning' | 'error' | 'glass';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
  children: ReactNode;
  pill?: boolean;
}

const styles: Record<Variant, string> = {
  default:
    'bg-white/10 text-white border-white/15',
  magenta:
    'bg-[color:var(--color-brand-magenta)]/15 text-[color:var(--color-brand-magenta-light)] border-[color:var(--color-brand-magenta)]/30',
  gold:
    'bg-[color:var(--color-gold)]/15 text-[color:var(--color-gold-light)] border-[color:var(--color-gold)]/30',
  navy:
    'bg-[color:var(--color-brand-navy)]/30 text-white border-white/10',
  success:
    'bg-[color:var(--color-success)]/15 text-[color:var(--color-success)] border-[color:var(--color-success)]/30',
  warning:
    'bg-[color:var(--color-warning)]/15 text-[color:var(--color-warning)] border-[color:var(--color-warning)]/30',
  error:
    'bg-[color:var(--color-error)]/15 text-[color:var(--color-error)] border-[color:var(--color-error)]/30',
  glass:
    'glass-card text-white border-white/15 backdrop-blur-md',
};

export function Badge({
  variant = 'default',
  pill = false,
  className,
  children,
  ...rest
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 border px-2.5 py-1 text-[11px] font-[family-name:var(--font-label)] uppercase tracking-[0.12em]',
        pill ? 'rounded-full' : 'rounded-md',
        styles[variant],
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
